import { useTranslation } from 'react-i18next';
import { IconMail } from '@tabler/icons-react';

const WHATSAPP_URL = 'https://wa.me/886910811426';
const LINE_URL = 'https://liff.line.me/1645278921-kWRPP32q/?accountId=477lqifx';
const DISCORD_URL = 'https://discord.gg/H6McMYzJJJ';

export function HelpSection() {
  const { t } = useTranslation();

  return (
    <div className="p-6 flex flex-col items-start">
      <h2 className="text-lg md:text-xl font-semibold border-l-4 border-sky-500 pl-4 py-0 mb-8 text-slate-900">
        {t('success.help.title')}
      </h2>
      <p className="text-slate-600 mb-2">
        {t('success.help.contact')}
      </p>
      <p className="text-sm md:text-sm text-slate-600 flex items-center gap-2 mb-6 border border-slate-200 rounded-lg p-2 bg-slate-100">
        <IconMail size={24} className="text-slate-600" />
        contact@clarymind.com
      </p>
      <p className="text-slate-600 mb-2">
        {t('success.help.otherChannels')}
      </p>
      <div className="flex items-center gap-2.5">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80 transition-opacity"
        >
          <img
            src="/brands/whatsapp.svg"
            alt="WhatsApp"
            className="w-10 h-10 rounded-lg"
          />
        </a>
        <a
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80 transition-opacity"
        >
          <img
            src="/brands/discord.jpg"
            alt="Discord"
            className="w-10 h-10 rounded-lg"
          />
        </a>
        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80 transition-opacity"
        >
          <img
            src="/brands/line.png"
            alt="LINE"
            className="w-10 h-10 rounded-lg"
          />
        </a>
      </div>
    </div>
  );
}
